module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../axios/index.js
// module id = 211
// module chunks = 1